<div style="overflow-x: auto;">
  <table class="basicTable" [attr.aria-busy]="loading">
    <thead>
      <tr>
        <th colspan="10" class="colheader">Network Elements</th>
      </tr>
      <tr>
        <th>NE Name</th>
        <th>NE Type</th>
        <th>Class Code</th>
        <th>OS Family</th>
        <th>Application Tag</th>
        <th>Environment</th>
        <th>CPU Count</th>
        <th>CPU Core Count</th>
        <th>CPU Core Thread</th>
        <th>RAM</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let ne of nes">
        <td><a [routerLink]="['/nes', ne.id]">{{ne.name}}</a></td>
        <td>{{ne.neTypeRecord?.name || ne.neType || ne.neTypeId || '—'}}</td>
        <td>{{ne.classCode?.code || ne.classCodeId || '—'}}</td>
        <td>{{ne.osFamily?.name || '—'}}</td>
        <td>{{ne.applicationTag?.name || ne.applicationTagId || '—'}}</td>
        <td><micro-environment-lookup *ngIf="ne.environmentId" [environmentId]="ne.environmentId"></micro-environment-lookup></td>
        <td>{{ne.cpuCount}}</td>
        <td>{{ne.cpuCoreCount}}</td>
        <td>{{ne.cpuCoreThread}}</td>
        <td>{{ne.ram}}</td>
      </tr>
      <tr *ngIf="loading"><td colspan="10"><em>Loading network elements…</em></td></tr>
      <tr *ngIf="loadFailed"><td colspan="10">Unable to load network elements. <button mat-button type="button" (click)="reload()">Retry</button></td></tr>
      <tr *ngIf="!loading && !loadFailed && nes.length === 0"><td colspan="10"><em>No network elements found for this cluster</em></td></tr>
    </tbody>
    <tfoot>
      <tr><td colspan="10"><mat-paginator (page)="reload()"></mat-paginator></td></tr>
    </tfoot>
  </table>
</div>
